import { createContext, useContext } from 'react'

export type RadioGroupOrientation = 'horizontal' | 'vertical'
export type RadioGroupVariant = 'boxed' | 'unboxed'
export interface RadioGroupContextValue {
  name: string
  selectedValue: string | null
  orientation: RadioGroupOrientation
  onChange: (value: string, event?: React.ChangeEvent<HTMLInputElement>) => void
  hasRadioMark: boolean
  variant: 'boxed' | 'unboxed'
}

export const RadioGroupContext = createContext<
  RadioGroupContextValue | undefined
>(undefined)

export const useRadioGroupContext = () => useContext(RadioGroupContext)
